import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-alt py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-211">
      <div className="max-w-[700px] mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-bg-card border-l-[3px] border-accent-orange rounded-r-lg p-4 md:p-5 shadow-card" data-id="element-213">
          <h2 className="text-[20px] font-bold text-text-primary mb-2.5 leading-[1.3]" data-id="element-214">
            Iron-Clad 3-Year Warranty + 30-Day 'Breathe Easy' Money-Back
            Guarantee
          </h2>
          <div className="space-y-2 text-[15px] text-text-secondary leading-[1.45] mb-4" data-id="element-215">
            <p data-id="element-216">
              Plug it in tonight. If you don't feel safer within 30 days —
              genuinely, noticeably safer — we'll refund every penny. No forms.
              No hassle. No questions asked.
            </p>
            <p data-id="element-217">
              AirGuard Pro is built to protect your family for up to 10 years.
              But we're not asking you to trust a promise. We're asking you to
              test it. If it doesn't earn your trust, you don't pay.
            </p>
          </div>
          <div className="text-center border-t border-border-subtle pt-4" data-id="element-218">
            <p className="text-[13px] text-text-secondary" data-id="element-219">
              📧 support@airguard-tech.com — Response within 24 hours
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}